import { usePage } from "@inertiajs/react"
import { Navigation } from "app/navigation"
import React, { useEffect } from "react"
import { Messages } from "./components/messages"
import { ApprovalBanner } from "app/account/approval-banner"
import { FreeOverLimitBanner } from "./components/free-over-limit-banner"
import { CancellationPendingBanner } from "./components/cancellation-pending-banner"
import { UnconfirmedUserEmailBanner } from "app/account/unconfirmed-user-email-banner"
import { UnconfirmedSendAddressBanner } from "app/account/unconfirmed-send-address-banner"
import { UnpaidBanner } from "./components/unpaid-banner"
import { TrialEndedBanner } from "./components/trial-ended-banner"
import { RequiredInfoBanner } from "./components/required-info-banner"
import {
  reportAndReload,
  clearLayoutReloadGuard
} from "./layout-config-sentry-context"

class InertiaPageHeaderErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error, info) {
    const reloading = reportAndReload(error, info, this.props.pageContext)
    if (!reloading) {
      this.setState({ hasError: true })
    }
  }

  render() {
    if (this.state.hasError) return <InertiaPageHeaderErrorFallback />
    return this.props.children
  }
}

function InertiaPageHeaderErrorFallback() {
  return (
    <div className="alert alert-warning m-0" role="alert">
      Couldn&apos;t load navigation. Try refreshing the page.
    </div>
  )
}

export function InertiaPageHeader() {
  const page = usePage()
  const {
    props: { layoutConfig }
  } = page

  const pageContext = {
    layoutConfig,
    url: page.url,
    component: page.component,
    version: page.version
  }

  return (
    <InertiaPageHeaderErrorBoundary pageContext={pageContext}>
      <InertiaPageHeaderContent layoutConfig={layoutConfig} />
    </InertiaPageHeaderErrorBoundary>
  )
}

function InertiaPageHeaderContent({ layoutConfig }) {
  useEffect(() => {
    clearLayoutReloadGuard()
  }, [])

  return (
    <>
      {layoutConfig.components.navbar.visible && (
        <Navigation {...layoutConfig.components.navbar.data} />
      )}

      {layoutConfig.components.messages.visible && (
        <Messages {...layoutConfig.components.messages.data} />
      )}

      {layoutConfig.components.inReview.visible && (
        <ApprovalBanner {...layoutConfig.components.inReview.data} />
      )}

      {layoutConfig.components.freeOverLimit.visible && (
        <FreeOverLimitBanner {...layoutConfig.components.freeOverLimit.data} />
      )}

      {layoutConfig.components.cancellationPending.visible && (
        <CancellationPendingBanner
          {...layoutConfig.components.cancellationPending.data}
        />
      )}

      {layoutConfig.components.unconfirmedUserEmail.visible && (
        <UnconfirmedUserEmailBanner
          {...layoutConfig.components.unconfirmedUserEmail.data}
        />
      )}

      {layoutConfig.components.unconfirmedSendAddress.visible && (
        <UnconfirmedSendAddressBanner
          {...layoutConfig.components.unconfirmedSendAddress.data}
        />
      )}

      {layoutConfig.components.unpaid.visible && <UnpaidBanner />}

      {layoutConfig.components.trialEnded.visible && <TrialEndedBanner />}

      {layoutConfig.components.requiredInfo.visible && (
        <RequiredInfoBanner {...layoutConfig.components.requiredInfo.data} />
      )}
    </>
  )
}
